import { render, staticRenderFns } from "./TicketingColumn.vue?vue&type=template&id=215551d2&scoped=true"
import script from "./TicketingColumn.vue?vue&type=script&lang=js"
export * from "./TicketingColumn.vue?vue&type=script&lang=js"
import style0 from "./TicketingColumn.vue?vue&type=style&index=0&id=215551d2&prod&scoped=true&lang=postcss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215551d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCardTitle,VFlex})
